module.exports = __webpack_public_path__ + "static/media/document-placeholder.6db540d8.svg";